import { isAxiosError } from 'axios'

import httpClient from '../../httpClient.ts'
import { Company, FetchResponse } from './types.ts'

const BASE_URL = '/api/company/'

const createCompany = async (data: Company) => {
  let fetchResponse: FetchResponse = {
    data: [],
    status: 200,
    error: null
  }
  try {
    const response = await httpClient.post(BASE_URL, data)
    fetchResponse.data = response.data
    fetchResponse.status = response.status
  } catch (error) {
    if (isAxiosError(error)) {
      fetchResponse.error = 'Coś poszło nie tak'
      fetchResponse.status = error.response?.status as number
    } else {
      fetchResponse.error = 'Możliwy brak połączenia z serwerem'
      fetchResponse.status = 500
    }
  }
  return fetchResponse
}

const getCompany = async () => {
  let fetchResponse: FetchResponse = {
    data: [],
    status: 200,
    error: null
  }

  try {
    const response = await httpClient.get<Company[]>(BASE_URL)
    fetchResponse.data = response.data
    fetchResponse.status = response.status
  } catch (error) {
    if (isAxiosError(error)) {
      fetchResponse.error = error.response?.statusText
      fetchResponse.status = error.response?.status as number
    } else {
      fetchResponse.error = 'Możliwy brak połączenia z serwerem'
      fetchResponse.status = 500
    }
  }

  return fetchResponse
}

export const companyAPI = {
  createCompany,
  getCompany
}
